module.exports = __webpack_public_path__ + "static/people_pop9-c227fc861eb3c889f9ad0a41cc0de7d3.png";